import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { CopiaProfiloModalComponent } from './copia-profilo-modal';

export const CopiaProfiloModalModule: string = ng
    .module('archiSmall.components.copiaProfiloModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('copiaProfiloModalComponent', CopiaProfiloModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/copia-profilo-modal/copia-profilo-modal.module.ts